// src/layouts/MainLayout.js
import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import AppNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import Toasts from '../components/ToastContainer';
import { Breadcrumb, Button } from 'react-bootstrap';

function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine if the current route is the homepage
  const isHome = location.pathname === '/';

  return (
    <>
      <AppNavbar />
      <div style={{ minHeight: '80vh', padding: '1rem' }}>
        {!isHome && (
          <div className="d-flex justify-content-start mb-3">
            <Breadcrumb className="mb-0">
              <Breadcrumb.Item>
                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={() => navigate(-1)}
                >
                  &larr; Back
                </Button>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        )}
        <Outlet />
      </div>
      <Footer />
      <Toasts/>
    </>
  );
}

export default MainLayout;
